import React from "react";
import "../styles/Footer.css";

export default function Footer(props) {
  return (
    <div id="footer">
      <a href="https://github.com/dlambden" target="_blank">
        Open-source code
      </a>{" "}
      by Darci Lambden
    </div>
  );
}
